import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-inps-capthca-modal',
    templateUrl: './inps-capthca-modal.component.html',
    styleUrls: ['./inps-capthca-modal.component.scss']
})
export class InpsCapthcaModalComponent implements OnInit {
    titolo = 'Inserisci il captcha';
    // tslint:disable-next-line: max-line-length
    captchaUrl = null as string;
    captchaForm: FormGroup;

    constructor(@Inject(MAT_DIALOG_DATA) public data: { captchaUrl: string }, public dialogRef: MatDialogRef<InpsCapthcaModalComponent>, private formBuilder: FormBuilder) {
        this.captchaUrl = data.captchaUrl;
    }

    ngOnInit() {
        this.captchaForm = this.formBuilder.group({
            captcha: ['', [Validators.required]],
        });
    }

    confermaCaptcha() {
        this.dialogRef.close(this.captchaForm.value['captcha']);
    }

}
